import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppEnums } from '../../../models/AppEnums';
import { CameraSearchCriteria } from '../../../models/searchCriteria/CameraSearchCriteria';
import { INSPECTION_CONF_SEARCH_CRITERIA_KEY, InspectionConfigurationSearchCriteria } from '../../../models/searchCriteria/InspectionConfigurationSearchCriteria';
import { InspectionConfiguration } from '../../../models/InspectionConfiguration';
import { InspectionConfigurationService } from '../../../services/inspection-configuration.service';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { AlertService } from '../../shared/alert/alert.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-inspection-provider-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ConfirmAlertComponent,
    FilterPanelComponent,
    HasPermissionDirective,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './inspection-provider-list.component.html',
  styleUrl: './inspection-provider-list.component.scss'
})
export class InspectionProviderListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: InspectionConfigurationSearchCriteria = { provider: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: InspectionConfigurationSearchCriteria = { ...this.emptySearchCriteria };
  inspectionConfigurations: InspectionConfiguration[] = [];

  selectedInspectionConfiguration?: InspectionConfiguration;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private inspectionConfigurationService: InspectionConfigurationService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {
    this.searchForm = this.fb.group({
      provider: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(INSPECTION_CONF_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, INSPECTION_CONF_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  edit(id?: number) {
    this.router.navigate(['inspections-config/' + id]);
  }

  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, INSPECTION_CONF_SEARCH_CRITERIA_KEY);
    this.inspectionConfigurationService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.inspectionConfigurations = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }


  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as CameraSearchCriteria
    this.find();
  }

  computeNameType(id: string) {
    return AppEnums.inspectionProviders.find(type => type.id === id)?.description
  }


  confirmOperation(inspectionConfiguration: InspectionConfiguration, confirmOperationType: "DEL" | undefined) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage = "Eliminazione camera - Sicuro di voler eliminare la configurazione " + inspectionConfiguration.provider;
    }
    this.selectedInspectionConfiguration = inspectionConfiguration;
  }


  cancelModalOperationExec() {
    this.selectedInspectionConfiguration = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.inspectionConfigurationService.delete(this.selectedInspectionConfiguration!.id!).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
          this.cancelModalOperationExec();
          this.fullSpinnerService.spinner(undefined);
          this.find()
        }, complete: () => {

        }
        , error: () => {
          this.cancelModalOperationExec();
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}

